import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Users, Package, TrendingUp } from 'lucide-react';
import { UserManagement } from './UserManagement';
import { ProductManagement } from './ProductManagement';
import { LineManagement } from './LineManagement';
interface MasterDataManagementProps {
  onBack: () => void;
}
type CategoryType = 'users' | 'products' | 'lines' | null;
export function MasterDataManagement({
  onBack
}: MasterDataManagementProps) {
  const [selectedCategory, setSelectedCategory] = useState<CategoryType>(null);
  const categories = [{
    id: 'users' as CategoryType,
    title: 'Benutzer',
    description: 'Mitarbeiter und Berechtigungen verwalten',
    icon: Users,
    color: 'blue'
  }, {
    id: 'products' as CategoryType,
    title: 'Produkte',
    description: 'Produktdaten und Spezifikationen',
    icon: Package,
    color: 'green'
  }, {
    id: 'lines' as CategoryType,
    title: 'Linien',
    description: 'Produktionslinien konfigurieren',
    icon: TrendingUp,
    color: 'orange'
  }];
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      icon: 'text-blue-600',
      hover: 'hover:bg-blue-100'
    },
    green: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      icon: 'text-green-600',
      hover: 'hover:bg-green-100'
    },
    orange: {
      bg: 'bg-orange-50',
      border: 'border-orange-200',
      icon: 'text-orange-600',
      hover: 'hover:bg-orange-100'
    }
  };
  // Show UserManagement when users category is selected
  if (selectedCategory === 'users') {
    return <div className="min-h-screen w-full bg-white" data-id="element-371">
        <div className="max-w-5xl mx-auto px-8 py-8" data-id="element-372">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} data-id="element-373">
            <div className="flex items-center gap-4 mb-6" data-id="element-374">
              <button onClick={() => setSelectedCategory(null)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Zurück" data-id="element-375">
                <ArrowLeft className="w-5 h-5 text-gray-600" strokeWidth={2} data-id="element-376" />
              </button>
              <h1 className="text-3xl font-semibold text-gray-900" data-id="element-377">
                Stammdatenverwaltung
              </h1>
            </div>

            <UserManagement onBack={() => setSelectedCategory(null)} data-id="element-378" />
          </motion.div>
        </div>
      </div>;
  }
  // Show ProductManagement when products category is selected
  if (selectedCategory === 'products') {
    return <div className="min-h-screen w-full bg-white" data-id="element-379">
        <div className="max-w-5xl mx-auto px-8 py-8" data-id="element-380">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} data-id="element-381">
            <div className="flex items-center gap-4 mb-6" data-id="element-382">
              <button onClick={() => setSelectedCategory(null)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Zurück" data-id="element-383">
                <ArrowLeft className="w-5 h-5 text-gray-600" strokeWidth={2} data-id="element-384" />
              </button>
              <h1 className="text-3xl font-semibold text-gray-900" data-id="element-385">
                Stammdatenverwaltung
              </h1>
            </div>

            <ProductManagement onBack={() => setSelectedCategory(null)} data-id="element-386" />
          </motion.div>
        </div>
      </div>;
  }
  // Show LineManagement when lines category is selected
  if (selectedCategory === 'lines') {
    return <div className="min-h-screen w-full bg-white" data-id="element-387">
        <div className="max-w-5xl mx-auto px-8 py-8" data-id="element-388">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} data-id="element-389">
            <div className="flex items-center gap-4 mb-6" data-id="element-390">
              <button onClick={() => setSelectedCategory(null)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Zurück" data-id="element-391">
                <ArrowLeft className="w-5 h-5 text-gray-600" strokeWidth={2} data-id="element-392" />
              </button>
              <h1 className="text-3xl font-semibold text-gray-900" data-id="element-393">
                Stammdatenverwaltung
              </h1>
            </div>

            <LineManagement onBack={() => setSelectedCategory(null)} data-id="element-394" />
          </motion.div>
        </div>
      </div>;
  }
  return <div className="min-h-screen w-full bg-white" data-id="element-395">
      <div className="max-w-5xl mx-auto px-8 py-8" data-id="element-396">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} data-id="element-397">
          <div className="flex items-center gap-4 mb-6" data-id="element-398">
            <button onClick={onBack} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Zurück" data-id="element-399">
              <ArrowLeft className="w-5 h-5 text-gray-600" strokeWidth={2} data-id="element-400" />
            </button>
            <h1 className="text-3xl font-semibold text-gray-900" data-id="element-401">
              Stammdatenverwaltung
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8" data-id="element-402">
            {categories.map(category => {
            const colors = colorClasses[category.color as keyof typeof colorClasses];
            const Icon = category.icon;
            return <motion.button key={category.id} onClick={() => setSelectedCategory(category.id)} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4
            }} className={`${colors.bg} ${colors.border} ${colors.hover} border-2 rounded-xl p-6 text-left transition-all hover:shadow-lg`} data-id="element-403">
                  <div className={`${colors.icon} mb-3`} data-id="element-404">
                    <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-405" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-1" data-id="element-406">
                    {category.title}
                  </h2>
                  <p className="text-sm text-gray-600" data-id="element-407">
                    {category.description}
                  </p>
                </motion.button>;
          })}
          </div>

          {/* Placeholder for future category views */}
          {selectedCategory && selectedCategory !== 'users' && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6 p-6 bg-gray-50 rounded-xl border border-gray-200" data-id="element-408">
              <p className="text-gray-600 text-center text-sm" data-id="element-409">
                {selectedCategory === 'products' && 'Produktverwaltung wird hier angezeigt'}
                {selectedCategory === 'lines' && 'Linienverwaltung wird hier angezeigt'}
              </p>
            </motion.div>}
        </motion.div>
      </div>
    </div>;
}